import { create } from 'zustand'

const accordionStore = create((set) => ({
  activeId: null, // Tracks which item is open
  toggle: (id) => 
    set((state) => ({ 
      activeId: state.activeId === id ? null : id 
    })),
}))

export default accordionStore